import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'data.email_template.advanced_editor',
  })
  let setFlowTo = useSetFlowTo(props.viewPath)
  return function onClick() {
    change(true)
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
